import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from "../../../hooks/useAuth";
import Logo123Milhas from "../../../../images/123-milhas-logo.svg";
import { CardStyled, CardHeaderStyled, SeparatorPlusStyled, Image, CardContentStyled, } from "./styles";
export function Card(_a) {
    var children = _a.children;
    var isFidelity = useAuth().isFidelity;
    return (_jsxs(CardStyled, { children: [isFidelity && (_jsxs(CardHeaderStyled, { children: [_jsx(Image, { src: Logo123Milhas, alt: "123 Milhas" }), _jsx(SeparatorPlusStyled, { children: "+" })] })), _jsx(CardContentStyled, { children: children })] }));
}
